import { handleActions } from 'redux-actions';
import { rerenderApplication, setHeader } from './actions';

const initialState = {
  isHeaderActive: true,
};

const setHeaderReducer = (state = initialState, { payload }) => {
  return {
    ...state,
    isHeaderActive: payload,
  };
};
const setRerenderApplication = (state = initialState, { payload }) => {
  return {
    ...state,
    reloadApplication: payload,
  };
};

const reducer = handleActions(
  {
    [setHeader]: setHeaderReducer,
    [rerenderApplication]: setRerenderApplication,
  },
  initialState,
);

export default reducer;
